import { getValidNumber } from './formatNumber';
import { getNumberFormatter } from './numberFormatter';

export const formatUsdValue = (price: number | null | undefined, noDecimals?: boolean): string => {
  const { isValid, value } = getValidNumber(price);

  if (!isValid || value === null) {
    return '$ 0.00';
  }

  const decimals = noDecimals ? 0 : 2;
  const formatted = getNumberFormatter(decimals, decimals, 'currency').format(value);

  return formatted.replace('$', '$ ');
};
